const filters = document.querySelectorAll('[data-filter]');
const projects = document.querySelectorAll('.project');
filters.forEach(button => button.addEventListener('click', () => {
  filters.forEach(item => { const active = item === button; item.classList.toggle('active', active); item.setAttribute('aria-pressed', String(active)); });
  projects.forEach(project => { project.hidden = button.dataset.filter !== 'all' && project.dataset.category !== button.dataset.filter; });
}));
const dialog = document.querySelector('#detail');
projects.forEach(project => project.addEventListener('click', () => {
  dialog.querySelector('img').src = project.querySelector('img').src;
  dialog.querySelector('img').alt = project.querySelector('img').alt;
  dialog.querySelector('h2').textContent = project.dataset.caption;
  dialog.querySelector('.description').textContent = project.dataset.description;
  dialog.showModal();
}));
dialog.querySelector('.close').addEventListener('click', () => dialog.close());
dialog.addEventListener('click', event => { if (event.target === dialog) { const bounds = dialog.getBoundingClientRect(); if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close(); } });
